import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=2dfc8b2e&scoped=true&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"
import style0 from "./form-item.vue?vue&type=style&index=0&id=2dfc8b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc8b2e",
  null
  
)

export default component.exports